module.exports = __webpack_public_path__ + "img/not-authorized.299c8ffd.svg";